module.exports = __webpack_public_path__ + "media/organizations/HTWK-33401410.webp";